import React from 'react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface SocialLink {
  platform: string;
  url: string;
}
interface SocialLinksEditorProps {
  links: SocialLink[];
  platformOptions: string[];
  onLinkChange: (index: number, field: 'platform' | 'url', value: string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
}
export const SocialLinksEditor: React.FC<SocialLinksEditorProps> = ({
  links,
  platformOptions,
  onLinkChange,
  onAdd,
  onRemove
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  return <div data-id="element-636" data-mp="3si81ezbpqsqr">
      <div className="flex justify-between items-center mb-3" data-id="element-637" data-mp="3sholfo5miefd">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-638" data-mp="1cykry9lzqtt">
          Social Media Links
        </label>
        <button type="button" onClick={onAdd} className={`text-sm font-medium ${rt.accentLink}`} data-id="element-639" data-mp="17rz85fkkj0os">
          + Add Link
        </button>
      </div>
      <div className="space-y-2" data-id="element-640" data-mp="29killoa6qmfh">
        {links.map((link, index) => <div key={index} className={`flex items-center gap-2 p-3 rounded-lg border ${dk.border} ${dk.surfaceMuted}`} data-id="element-641" data-mp="25jf4kygeikco" data-mpi={index}>
            <select value={link.platform} onChange={e => onLinkChange(index, 'platform', e.target.value)} className={`block w-1/3 rounded-md border sm:text-sm focus:outline-none focus:ring-2 px-2 py-2 ${rt.inputFocus} ${dk.input}`} data-id="element-642" data-mp="20j0xbimmjefp">
              <option value="" data-id="element-643" data-mp="1luee35tvm2j7">Platform</option>
              {platformOptions.map(opt => <option key={opt} value={opt} data-id="element-644" data-mp="1huvtyc9vpvhf">
                  {opt}
                </option>)}
            </select>
            <input type="url" value={link.url} placeholder="https://" onChange={e => onLinkChange(index, 'url', e.target.value)} className={`block flex-1 rounded-md border sm:text-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.input}`} data-id="element-645" data-mp="1ctgd6weqib4u" />
            <button type="button" onClick={() => onRemove(index)} className="text-red-500 hover:text-red-700 p-1.5 rounded-md hover:bg-red-50" data-id="element-646" data-mp="y9lwkhnulapr">
              ×
            </button>
          </div>)}
      </div>
    </div>;
};